'use client';

import { useState } from 'react';

import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

import AuthInitializer from '@/components/auth/AuthInitializer';
import GuestHomePage from '@/components/home/GuestHomePage';
import WelcomeSection from '@/components/home/WelcomeSection';
import { signOut } from '@/features/auth/authSlice';
import { useAppDispatch, useAppSelector } from '@/store/hooks';

const Spinner = () => (
  <div className="flex items-center justify-center min-h-screen bg-gray-50">
    <div className="w-12 h-12 border-t-2 border-b-2 border-amber-500 rounded-full animate-spin"></div>
  </div>
);

function MinimalHeader() {
  const dispatch = useAppDispatch();
  const router = useRouter();

  const handleSignOut = async () => {
    await dispatch(signOut());
    router.push('/auth/login');
  };

  return (
    <header className="bg-white border-b border-gray-200">
      <nav className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link href="/">
          <Image
            src="/finkr-logo.svg"
            alt="Finkr Logo"
            width={120}
            height={40}
            priority
            className="h-8 w-auto"
          />
        </Link>
        <button
          onClick={handleSignOut}
          className="text-sm font-medium text-gray-500 hover:text-gray-700 transition-colors"
        >
          Sign out
        </button>
      </nav>
    </header>
  );
}

export default function HomePage() {
  const { user, isAuthenticated } = useAppSelector((state) => state.auth);
  const [loading, setLoading] = useState(true);

  const handleAuthComplete = () => {
    setLoading(false);
  };

  const handleAuthError = (error: any) => {
    console.error('Auth initialization error:', error);
    setLoading(false);
  };

  return (
    <>
      <AuthInitializer onComplete={handleAuthComplete} onError={handleAuthError} />
      {loading ? (
        <Spinner />
      ) : isAuthenticated ? (
        <main className="min-h-screen bg-gray-50">
          <MinimalHeader />
          <WelcomeSection userName={user?.firstName || 'Valued User'} />
        </main>
      ) : (
        <GuestHomePage />
      )}
    </>
  );
}
